import Img5 from 'assets/images/margin-onboarding-5.png'
import I18n from 'components/I18n'
import messages from 'lang'
import React, { useState } from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import { Button, ButtonWrapper, ContentWrapper, Img, Title, Wrapper } from './common'

const Description = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: baseline;
  color: ${color('title')};
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0 0 2.5rem 0;

  > p {
    flex: 1;
    margin: 0;
  }
`
const Checkbox = styled.input``

type Props = { onNext: () => void }

const Agreement = ({ onNext }: Props) => {
  const [checked, setChecked] = useState(false)
  return (
    <Wrapper>
      <Img src={Img5} />
      <ContentWrapper>
        <Title>
          <I18n data={messages.margin_onboarding_agreement_title} />
        </Title>
        <Description>
          <Checkbox
            name='leverageAgreement'
            onChange={() => setChecked(!checked)}
            checked={checked}
            type='checkbox'
          />
          <p onClick={() => setChecked(!checked)}>
            <I18n
              data={messages.margin_onboarding_agreement_description}
              link={
                <a
                  href='https://exchange.blockchain.com/legal/margin'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <I18n data={messages.terms_conditions} />
                </a>
              }
            />
          </p>
        </Description>
        <ButtonWrapper>
          <Button disabled={!checked} onClick={onNext}>
            <I18n data={messages.margin_onboarding_agreement_cta} />
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}

export default Agreement
